
import { QueryRequestProvider } from '../../../component/request'
import { QueryResponseProvider } from '../../../component/response'
import { ComponentRequest } from '../../../component/componentLayout'
import { ListViewProvider } from '../../../component/view'
import { getReportList } from '../api'


/**
 * comRequest
 * Configuration object for ALL Report type.
 * Used to set up the report context and filtering options.
 */
const comRequest = { type: "projectReport", label: "ALL Report", company_filter: false }

/**
 * ReportWrapper
 * Provides context and API integration for all reports.
 * Wraps children with multiple providers for state and data management.
 * @param {React.ReactNode} children - Child components to render inside the wrapper.
 */
const ReportWrapper = ({ children }) => {
    // getApi: function to fetch report list based on query
    const getApi = (query) => {
        return getReportList(query);
    }

    return <ComponentRequest.Provider value={{ comRequest }}>
        <QueryRequestProvider>
            <QueryResponseProvider getApi={getApi}>
                <ListViewProvider>
                    {children}
                </ListViewProvider>
            </QueryResponseProvider>
        </QueryRequestProvider>
    </ComponentRequest.Provider>
}

export { ReportWrapper }